import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Loader.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Loader = function Loader(_ref) {
  var background = _ref.background,
    fadeOut = _ref.fadeOut,
    progress = _ref.progress,
    transparent = _ref.transparent,
    blackandwhite = _ref.blackandwhite,
    small = _ref.small;
  var screenClasses = classNames('loading-screen', {
    transparent: transparent,
    'fade-out': fadeOut
  });
  var containerClasses = classNames('a-loader-container', {
    blackandwhite: blackandwhite,
    small: small
  });
  var style = null;
  if (background) {
    style = {
      background: background
    };
  }
  return /*#__PURE__*/_jsx("div", {
    className: screenClasses,
    style: style,
    children: /*#__PURE__*/_jsx("div", {
      className: "loading-screen-content-wrap",
      children: /*#__PURE__*/_jsx("div", {
        className: "loading-screen-content",
        children: /*#__PURE__*/_jsxs("div", {
          className: containerClasses,
          children: [/*#__PURE__*/_jsx("i", {
            className: "i1"
          }), /*#__PURE__*/_jsx("i", {
            className: "i2"
          }), /*#__PURE__*/_jsx("i", {
            className: "i3"
          }), /*#__PURE__*/_jsx("i", {
            className: "i4"
          }), progress ? /*#__PURE__*/_jsxs("div", {
            className: "a-loader-progress",
            children: [progress, " %"]
          }) : null]
        })
      })
    })
  });
};
Loader.propTypes = {
  background: PropTypes.string,
  fadeOut: PropTypes.bool,
  progress: PropTypes.number,
  transparent: PropTypes.bool,
  blackandwhite: PropTypes.bool,
  small: PropTypes.bool
};
export default Loader;